import type { FeaturedService } from './types'

export const featuredServices: readonly FeaturedService[] = [
  {
    serviceId: 'mailbox-rental',
    title: 'Mailbox Rental',
    summary: 'A secure local address for mail and eligible package receiving.',
    ctaLabel: 'Learn more',
  },
  {
    serviceId: 'fedex-shipping',
    title: 'FedEx Shipping',
    summary: 'Convenient shipping help from a neighborhood service center.',
    ctaLabel: 'Learn more',
  },
  {
    serviceId: 'usps-shipping',
    title: 'US Postal Service',
    summary: 'Mailing, postage, and USPS shipping help at the counter.',
    ctaLabel: 'Learn more',
  },
  {
    serviceId: 'printing-copying',
    title: 'Print & Document Services',
    summary: 'Copies, printing, and finishing for home and business.',
    ctaLabel: 'Learn more',
  },
  {
    serviceId: 'packing-services',
    title: 'Professional Packing',
    summary: 'Careful packing assistance for everyday and unusual items.',
    ctaLabel: 'Learn more',
  },
  {
    serviceId: 'custom-box-making',
    title: 'Custom Box Making',
    summary: 'Right-sized packaging for unusual shapes and sizes.',
    ctaLabel: 'Learn more',
  },
]
